<template>
  <div class="album-item">
    <div class="card">
      <div class="card-image">
        <div class="cover-wrapper">
          <div
            class="cover"
            :style="{ 'background-image': `url('${album.image}')` }"
          ></div>
        </div>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title is-4">{{ album.name }}</p>
            <p class="subtitle is-6">{{ album.artist }}</p>
          </div>
        </div>

        <div class="content">
          <time :datetime="album.published">{{ album.published }}</time>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlbumItem",
  props: {
    album: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
$radius: 4px;

.album-item {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
  border-radius: $radius;
  background-color: white;
  overflow: hidden;
  cursor: pointer;

  .cover-wrapper {
    overflow: hidden;
  }

  .cover {
    width: 100%;
    height: 100%;
    background-color: #cccccc;
    height: 300px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-top-left-radius: $radius;
    border-top-right-radius: $radius;
    transition: all 0.5s;
  }

  .info {
    padding: 1em;
    font-weight: 600;
  }
}

.album-item:hover .cover,
.album-item:focus .cover {
  transform: scale(1.2);
}
</style>
